export async function api<T = unknown>(
  url: string,
  options: RequestInit = {},
  token?: string
): Promise<T | null> {
  const { headers: customHeaders, ...restOptions } = options;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(customHeaders as Record<string, string> | undefined || {}),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(url, { ...restOptions, headers });
  if (res.status === 204) return null;
  const text = await res.text();
  if (!res.ok) throw new Error(text || `HTTP ${res.status}`);
  return text ? (JSON.parse(text) as T) : null;
}
